import React, {useState, useEffect} from "react";
import request from "../Requests/requests";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
// import { CheckTimeZone } from "./CheckTimeZone";
import { sendDataLayer } from "../utils/sendDataLayer";
import Cookies from 'universal-cookie';
import Validation from "../UIcomponents/Validation/Validation";
import { useDispatch } from "react-redux";
import { loadUserSettings } from "../store/settingsReducer";
import { ReactComponent as UserEmail } from "../icons/svg/Feedback/email.svg";
import { ReactComponent as UserPass } from "../icons/svg/Feedback/pass.svg";  
import useTimeZone from "../customHooks/useTimeZone";
import AuthVariants from "../Pages/Login/AuthVariants/AuthVariants";
import FailureAuth from "../Pages/Login/AuthVariants/AuthStatusPage/FailureAuth";
import Loader from "../Loader/Lodaer";
import { getUserData } from "../features/user/getUserData";
import DefaultInput from "../UIcomponents/DefaultInput/DefaultInput";
import Button from "../UIcomponents/Button/Button";
import ToolTipComponent from "../UIcomponents/Tooltips/Tooltip";

export default function AuthUser() {
  const AuthChanel = new BroadcastChannel('Auth');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isDisabled, setIsDisabled] = useState(true);
  const [isAuthError, setIsAuthError] = useState(false);
  const [autoOpen, setAutoOpen] = useState(false);
  const [checkedPrivacy, setCheckedPrivacy] = useState(true);
  const [errorAuth, setErrorAuth] = useState({
    emailErr: '',
    typeAuth: ''
  })
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isLoadingAuthSocial, setIsLoadingAuthSocial] = useState(false)
  const focusEmail = document.getElementById('email')
  const { getCurrentTimeZone } = useTimeZone()
  const cookies = new Cookies();
  let arrErrors = new Array([]);
  const [dataErrors, setDataErrors] = useState([]);
  const [windowScreen, setWindowScreen] = useState(window.screen.width);

  const stylesList = {
    width: windowScreen > 410 ? '334px' : '268px',
    backgroundColor: '#F8C440',
    top: windowScreen > 410 ? '120%' : '-240%',
    left: windowScreen > 410 && windowScreen < 992 ? '-135%' : windowScreen < 410 ? '16%' : '-7%',
    transform: windowScreen > 410 ? null : 'translateX(-25%)'
  }
  const stylesListArrow = {
    top: windowScreen > 410 ? '-8%' : '80%',
    left: windowScreen > 410 ? '7.5%' : '10%'
  }

  useEffect(() => {
    const handleUpdateScreenWidth = () => {
      setWindowScreen(window.screen.width)
    }

    window.addEventListener('resize', handleUpdateScreenWidth);

    return () => {
      window.removeEventListener('resize', handleUpdateScreenWidth);
    };
  }, [windowScreen])

  const hadnleLogin = async (res) => {
    setLoading(false)
    sendDataLayer('auth_password', 'auth_password')
    localStorage.setItem('userID', res.data.id);
    localStorage.setItem('firstName', res.data.firsName);
    localStorage.setItem('lastName', res.data.lastName === null ? '' : res.data.lastName);    
    localStorage.setItem('interceptorTry', 'false');
    cookies.set('refreshToken', res.data.refreshToken, {maxAge: 24*60*60*7})
    cookies.set('accessToken', res.data.token, {maxAge: 24*60*60*7})
    navigate('/');
    dispatch(getUserData())
    await request.get('/Settings/', {
      params: {UserId: res.data.id }
    }).then(response => {
        dispatch(loadUserSettings(response.data))
        localStorage.setItem('isTimeTracking', response.data.isTimeTracking);
        
      });
  }

  useEffect(() => {
    if (localStorage.getItem('userID')) {
      navigate('/', { replace: true })
    }
  }, [])// eslint-disable-line react-hooks/exhaustive-deps

  /* eslint-disable-next-line */
  let emailReg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
  /* eslint-disable-next-line */
  useEffect(() => {
    if ((email !== '') && (password !== '')) {
      setIsDisabled(false)
    } else {
      setIsDisabled(true)
    }
  }, [email, password]);
  
  useEffect(() => {
    
    AuthChanel.onmessage = (e) => {
        // const payload = {
        //   code: e.data.payload.code,
        //   deviceId: e.data.payload.deviceId,
        //   codeVerifier: localStorage.getItem('codeVerifier'),
        //   timeZoneId: getCurrentTimeZone()
        // }
        request.post(`/auth/${e.data.type}/callback`, {
          code: e.data.payload.code,
          ...(e.data.payload.deviceId != null && { deviceId: e.data.payload.deviceId }),
          ...(localStorage.getItem('codeVerifier') !== null && {codeVerifier: localStorage.getItem('codeVerifier')}),
          timeZoneId: getCurrentTimeZone()
        })
        .then((res) => {
          setIsLoadingAuthSocial(false)
          hadnleLogin(res)
        })
        .catch((error) => {
          setIsLoadingAuthSocial(false)
          const emailPattern = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g
          const mail = `${error.response.data}`
          const result = mail.match(emailPattern) ?? ''
          setErrorAuth({
            emailErr: `${result}`,
            typeAuth: `${e.data.type}`
          })
          setIsAuthError(true)
        })
        localStorage.removeItem('codeVerifier')    
    }

    return () => {
      AuthChanel.close();
    }
    // eslint-disable-next-line
  }, [AuthChanel])

  const authHandler = () => {
    if (!checkedPrivacy) {
      setAutoOpen(true)
    } else {
      setIsLoadingAuthSocial(true)
    }
  }
  
  function handleSubmit() {
    // e.preventDefault();
    if (emailReg.test(email) === true) {
      setLoading(true)
      setDataErrors([])
      request.post('/Account/Login', {  
            email: email,
            password: password})
            .then(res => {
              hadnleLogin(res)
            })
            .catch((error) => {
              setLoading(false)
              
              if (error.response.data.errors) {
                let arrGetError = Object.entries(error.response.data.errors)
                  arrGetError.forEach(([key, value]) => {
                    value.map(err => arrErrors.push({key, err}))
                    setDataErrors(arrErrors)
                  })
              }
            })
            // .catch((error) => {
            //   setLoading(false)
            //   if(error.response.data.errors.Email != null){
            //     let lengthEmail = error.response.data.errors.Email.length;
            //     let errors = "";
            //     for(let i = 0; i < lengthEmail; i++){
            //         errors += "* " + error.response.data.errors.Email[i] + "\r\n";
            //     }
            //     setErrorEmail(errors)
            //     setIsHiddenEmailErr(false);
            //   }else{
            //     setErrorEmail("");
            //     setIsHiddenEmailErr(true);
            //   }
  
            //   if(error.response.data.errors.Password != null){
            //     let lengthPassword = error.response.data.errors.Password.length;
            //     let errors = "";
            //     for(let i = 0; i < lengthPassword; i++ ){
            //       errors += "* " + error.response.data.errors.Password[i] + "\r\n";
            //     }
            //     setErrorPassword(errors)
            //     setIsHiddenPassErr(false);
            //   }else{
            //     setErrorPassword("");
            //     setIsHiddenPassErr(true);
            //   }
              
            // })
          }
    else {
      arrErrors.push({key: 'Email', err: 'некорректный email'});
      setDataErrors(arrErrors)
      focusEmail.focus()
    }
  }

  if (isLoadingAuthSocial) {
    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
        <Loader />
      </div>
    )
  }

            return (
              <>
                {
                  isAuthError ? <FailureAuth emailErr={errorAuth.emailErr} 
                                              typeAuth={errorAuth.typeAuth} 
                                              setIsAuthError={setIsAuthError}/> : 
                  <div className="register-form__page">
                      <div className="register-form__container">
                      <h2 className="register-form__heading">Вход в аккаунт</h2>
                        <form autoComplete="on" onSubmit={handleSubmit} className='register-form__form'>
                          <div style={{width: "100%"}}>
                          <DefaultInput logo={<UserEmail width={'18px'} height={'18px'}/>} placeHolder="E-mail" inputType="email" inputValue={email} onChangeFunc={setEmail}>
                            <Validation data={dataErrors} keyItem={'Email'}/>
                          </DefaultInput>
                          </div>
                          <div style={{width: "100%"}}>
                            <DefaultInput logo={<UserPass />} placeHolder="Пароль" inputType="password" inputValue={password} onChangeFunc={setPassword}>
                              <Validation data={dataErrors} keyItem={'Password'}/>
                            </DefaultInput>
                          </div>
                            <Button onClickFunc={handleSubmit} btnSize="xl" btnType="filled" title="Войти" disabled={isDisabled} loading={loading} />
                            <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                              <p className="login-description">
                                  Забыли пароль? <Link to="/forgot_password">Восстановить</Link>
                              </p>
                              <p className="login-description">
                                Еще нет аккаунта? <Link to="/register">Зарегистрироваться</Link>
                              </p>
                            </div>
                            <ToolTipComponent autoOpen={autoOpen} autoOpenHandler={setAutoOpen} stylesList={stylesList} stylesListArrow={stylesListArrow} tooltipDescription="Необходимо дать согласие на обработку персональных данных">
                              <div className="privacy-check checkList">
                                <label className="label_to_checkBox privacy-label" style={{alignItems: 'center'}}>
                                  <input type="checkbox" className="checkList_checkbox" checked={checkedPrivacy} onClick={() => setCheckedPrivacy(!checkedPrivacy)}/>
                                  <span></span>
                                  Я принимаю 
                                  <a href="https://timetask.ru/privacy" rel="noreferrer" className="privacy-link" target="_blank" style={{marginLeft: '3px'}}>Политику конфиденциальности</a> 
                                </label>
                              </div>
                            </ToolTipComponent>
                        </form>
                        <AuthVariants isPrivacyPolicy={checkedPrivacy} onClickFunction={() => authHandler()}/>
                      </div>
                  </div>
                }
              </>               
            )
}